var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * true - go fullscreen
 * false - exit fullscreen
 * undefined - toggle fullscreen
 */
export function toggleFullscreen(forceFullscreenState) {
    var e_1, _a;
    if (!document.fullscreenElement && forceFullscreenState !== false) {
        var elem = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen().catch(function (e) { return console.warn(e); });
        }
        else {
            var browserPrefixes = ["webkit", "moz", "ms", "o"];
            var unknownElem = elem;
            try {
                for (var _b = __values(browserPrefixes.map(function (prefix) { return prefix + "RequestFullScreen"; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    if (typeof unknownElem[key] === "function") {
                        unknownElem[key]();
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    }
    else {
        if (document.exitFullscreen && forceFullscreenState !== true) {
            document.exitFullscreen().catch(function (e) { return console.warn(e); });
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnVsbHNjcmVlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZ1bGxzY3JlZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLGdCQUFnQixDQUFDLG9CQUE4Qjs7SUFDN0QsSUFBSSxDQUFDLFFBQVEsQ0FBQyxpQkFBaUIsSUFBSSxvQkFBb0IsS0FBSyxLQUFLLEVBQUU7UUFDakUsSUFBTSxJQUFJLEdBQUcsUUFBUSxDQUFDLGVBQWUsQ0FBQztRQUN0QyxJQUFJLElBQUksQ0FBQyxpQkFBaUIsRUFBRTtZQUMxQixJQUFJLENBQUMsaUJBQWlCLEVBQUUsQ0FBQyxLQUFLLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFmLENBQWUsQ0FBQyxDQUFDO1NBQ3hEO2FBQU07WUFDTCxJQUFNLGVBQWUsR0FBRyxDQUFDLFFBQVEsRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLEdBQUcsQ0FBQyxDQUFDO1lBQ3JELElBQU0sV0FBVyxHQUFHLElBQTBDLENBQUM7O2dCQUMvRCxLQUFrQixJQUFBLEtBQUEsU0FBQSxlQUFlLENBQUMsR0FBRyxDQUFDLFVBQUMsTUFBTSxJQUFLLE9BQUcsTUFBTSxzQkFBbUIsRUFBNUIsQ0FBNEIsQ0FBQyxDQUFBLGdCQUFBLDRCQUFFO29CQUE1RSxJQUFNLEdBQUcsV0FBQTtvQkFDWixJQUFJLE9BQU8sV0FBVyxDQUFDLEdBQUcsQ0FBQyxLQUFLLFVBQVUsRUFBRTt3QkFDekMsV0FBVyxDQUFDLEdBQUcsQ0FBUyxFQUFFLENBQUM7cUJBQzdCO2lCQUNGOzs7Ozs7Ozs7U0FDRjtLQUNGO1NBQU07UUFDTCxJQUFJLFFBQVEsQ0FBQyxjQUFjLElBQUksb0JBQW9CLEtBQUssSUFBSSxFQUFFO1lBQzVELFFBQVEsQ0FBQyxjQUFjLEVBQUUsQ0FBQyxLQUFLLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFmLENBQWUsQ0FBQyxDQUFDO1NBQ3pEO0tBQ0Y7QUFDSCxDQUFDIn0=